<template>
    <div class="" style="">
        <div class="topImgContent">
            <div class="topImgTitleContent">
                <div class="topImgTitle">政务服务</div>
                <div class="topImgsubTitle">FUTURE SCIENCE CITY NEWS</div>
                <div class="e-flex menuContent">
                    <img class="ic_home" src="@/assets/images/ic_home.png">
                    <div class="pointer" @click="goMainPage()">首页</div>
                    <div>/</div>
                    <div class="pointer" @click="$router.push({ path: (from && from == 1) ? '/index/index' : '/governmentAffairsService/index', query: {}})">政务服务</div>
                    <div>/</div>
                    <div>正文</div>
                </div>
            </div>
        </div>
        <div class="e-flex" style="justify-content: center;">
            <div class="gase_detailContent">
                <div class="gase_detailTitle">{{ info.title }}</div>
                <div class="gase_detailCommon" v-html="info.content"></div>
            </div>
        </div>
        
    </div>
  </template>
  
  <script>
    import '../../styles/governmentAffairsService.css'
    export default {
      name: 'governmentAffairsServiceDetail',
      data () {
        return {
          from: '',
          id: '',
          info: {}
        }
      },
      created() {
        this.from = this.$route.query.from
        this.id = this.$route.query.id
        this.getDetail()
      },
      methods: {
        goMainPage() {
          this.$emit('goNavPage', {
            key:'1',
            path: ['1'],
            pathId: '1'
          })
        },
        getDetail() {
          this.request({
              url: 'governmentService/detail',
              method: 'POST',
              data: {
                id: this.id
              }
          }).then(res => {
              this.info = res.data
          })
        }
      }
    }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
  
  </style>
  


// WEBPACK FOOTER //
// src/view/governmentAffairsService/governmentAffairsServiceDetail.vue